
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { TrendingUp } from 'lucide-react';
import { InsightItem } from './types/insightTypes';
import TooltipExplanation from '@/components/musicians/card/TooltipExplanation';

interface AIPoweredInsightsProps {
  insights: InsightItem[];
}

const AIPoweredInsights: React.FC<AIPoweredInsightsProps> = ({ insights }) => {
  return (
    <Card className="bg-card/95 border-border/50 overflow-hidden">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2 text-white/95">
          <TrendingUp className="h-5 w-5 text-soundcharts-purple" />
          AI-Powered Insights
        </CardTitle>
        <CardDescription className="text-white/70">Career insights based on your data and industry trends</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4 py-4">
        {insights.map((insight, index) => (
          <div key={index} className="p-4 border rounded-md border-soundcharts-purple/30 bg-black/20 hover:bg-black/30 transition-colors">
            <h3 className="text-md font-medium flex items-center gap-2 text-white/95">
              <insight.icon className="h-4 w-4 text-soundcharts-purple" />
              <TooltipExplanation 
                text={insight.title}
                explanation={insight.detailedExplanation}
              />
            </h3>
            <p className="text-sm text-white/70 mt-1">{insight.content}</p>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default AIPoweredInsights;
